<template>
    <div class="tooltip">
        <popper ref="popper"
            v-model="showPopper"
            placement='top-start'
            :offset="!isMobile?20:0"
            :visibleArrow='!isMobile'>
        </popper>
        <div ref="fly-piece" v-show="showPopper" class="my-picker__popper">
            <div class="content" :style="style">
                <slot></slot>
            </div>
        </div>
        <i class="el-icon-question tip-icon"
            style="color:#555;"
            @mouseenter="handleHover"
            @mouseleave="handleHover" ></i>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Popper from 'element-ui/lib/utils/vue-popper.js';

Popper.render = ( h ) => h( null );

export default Vue.extend({
    props: {
        width: {
            type: [String, Number]
        }
    },
    components: {
        Popper
    },
    data: function () {

        return {
            showPopper: false
        };

    },
    mounted () {

        ( this.$refs.popper as any ).popperElm = this.$refs['fly-piece'];
        ( this.$refs.popper as any ).referenceElm = this.$el;

    },
    methods: {
        handleHover () {

            this.showPopper = !this.showPopper;

        }
    },
    computed: {
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        style (): Record<string, string> {

            let promptWidth;
            if ( this.width ) {

                promptWidth = this.width;

            } else {

                promptWidth = this.isMobile ? '6.9rem' : '3.2rem';

            }
            return {
                '--prompt-width': promptWidth
            };

        }
    }

});
</script>
<style scoped lang="less">
.tooltip{
    position: relative;
    display: inline-block;
    z-index: 3;
    font-size: 0;
}
.tip-icon{
    color: #555;
    font-size: 0.16rem;
    cursor: pointer;
    vertical-align: middle;
}
.content{
    width: var(--prompt-width);
    @media @pc{
        // position:absolute;
        // left: 50%;
        // right: 50%;
        padding: 0.1rem;
        // width: 3.2rem;
        font-size: 0.16rem;
    }

    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 0.05rem;
    text-align: left;
    color: #fff;
    font-weight: 400;
    @media @mobile{
        font-size: 0.26rem;
        // width:6.9rem;
        padding: .24rem;
        margin:.1rem;
    }
}
.content a{
    color: #fff;
    text-decoration: underline;
    &:hover{
        .text{
            border: none;
        }
    }
}
.content p{
    margin: 0;
}
/* .reo-tip:hover .content{
    display: block !important;
} */
.content a .ui-icon{
    transform: scale(0.5) translateY(36%);
    display: inline-block;
}
.tip-hr{
    margin-bottom: 0.05rem;
}
@media @mobile {
    .tip-icon{
        font-size: 0.28rem;
    }
    div.content p{
        font-size: 0.24rem;
    }
}
</style>
